import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/register/Register')));

export const Customers = Loadable(lazy(() => import('../pages/customers/Customers')));
export const CustomerCreateEditPage = Loadable(
  lazy(() => import('../pages/customers/CustomerCreateEditPage'))
);
export const CustomerAnalytics = Loadable(
  lazy(() => import('../sections/@dashboard/whatsApp/customer/CustomerAnalytics'))
);

export const AccountManagerPage = Loadable(
  lazy(() => import('../pages/customers/AccountManagerPage'))
);
export const Partners = Loadable(lazy(() => import('../pages/partners/Partners')));
export const AnalyticsPage = Loadable(lazy(() => import('../pages/whatsApp/wallet/AnalyticsPage')));
export const PartnerCreateEditPage = Loadable(
  lazy(() => import('../pages/partners/PartnerCreateEditPage'))
);
export const PartnerAccountPage = Loadable(
  lazy(() => import('../pages/partners/PartnerAccountPage'))
);
export const PartnerProfilePage = Loadable(
  lazy(() => import('../pages/partners/PartnersProfilePage'))
);
export const BillingConfigPage = Loadable(lazy(() => import('../pages/billing/BillingConfigPage')));

export const GoogleWorkspace = Loadable(
  lazy(() => import('../pages/googleWorkspace/GoogleWorkspace'))
);
export const CustomerInfo = Loadable(
  lazy(() => import('../sections/@dashboard/googleWorkspace/WorkspaceCustomerInfo'))
);
export const Transactions = Loadable(lazy(() => import('../pages/googleWorkspace/Transactions')));

export const Users = Loadable(lazy(() => import('../pages/users/Users')));
export const UserNewEditPage = Loadable(lazy(() => import('../pages/users/UserNewEditPage')));
export const Teams = Loadable(lazy(() => import('../pages/teams/Teams')));
export const TeamNewEditPage = Loadable(lazy(() => import('../pages/teams/TeamNewEditPage')));

export const WhatsAppSettingsPage = Loadable(lazy(() => import('../pages/whatsApp/SettingsPage')));
export const WhatsAppTemplatesPage = Loadable(
  lazy(() => import('../pages/whatsApp/TemplatesPage'))
);
export const Rates = Loadable(lazy(() => import('../pages/whatsApp/Rates')));
export const PartnersWallet = Loadable(lazy(() => import('../pages/whatsApp/wallet/Partners')));
export const CustomersWallet = Loadable(lazy(() => import('../pages/whatsApp/wallet/Customers')));
export const WalletTransactions = Loadable(
  lazy(() => import('../pages/whatsApp/wallet/Transactions'))
);
export const SupportChannelPage = Loadable(
  lazy(() => import('../pages/supportChannel/SupportChannelPage'))
);
export const CustomerInvoice = Loadable(lazy(() => import('../pages/whatsApp/CustomerInvoice')));
export const FixDisplayName = Loadable(lazy(() => import('../pages/whatsApp/FixDisplayName')));

export const WhitelabelConfigPage = Loadable(
  lazy(() => import('../pages/whitelabel/WhitelabelConfigPage'))
);

export const CustomizeDemoForm = Loadable(
  lazy(() => import('../pages/whatsApp/demo/CostomizeDemo'))
);
export const DemoRecords = Loadable(lazy(() => import('../pages/whatsApp/demo/DemoRecords')));
export const DiscoveryCallStup = Loadable(
  lazy(() => import('../pages/whatsApp/discoveryCall/DiscoveryCallStup'))
);
export const DiscoveryCallList = Loadable(
  lazy(() => import('../pages/whatsApp/discoveryCall/DiscoveryCallList'))
);
export const DiscoveryDetails = Loadable(
  lazy(() => import('../pages/whatsApp/discoveryCall/DiscoveryDetails'))
);

export const OnboardConfigPage = Loadable(
  lazy(() => import('../pages/whatsApp/onboardConfig/OnboardConfig'))
);

export const ReportsPage = Loadable(lazy(() => import('../pages/reports/ReportsPage')));
export const ApiToken = Loadable(lazy(() => import('../pages/developers/apiToken')));
export const NotificationsPage = Loadable(
  lazy(() => import('../pages/notifications/notificationPage'))
);
export const BillingProfile = Loadable(lazy(() => import('../pages/whatsApp/BillingProfile')));
export const CouponPage = Loadable(lazy(() => import('../pages/coupons/CouponPage')));
export const CreateCoupon = Loadable(lazy(() => import('../pages/coupons/CreateCoupon')));
export const CouponView = Loadable(lazy(() => import('../pages/coupons/CouponView')));

export const BillingPayments = Loadable(lazy(() => import('../pages/whatsApp/BillingePayments')));
export const BillingPaymentsForm = Loadable(
  lazy(() => import('../pages/whatsApp/BillingPaymentsForm'))
);

export const SuperUserPage = Loadable(lazy(() => import('../pages/superUser/SuperUserPage')));
export const MemberOrganizations = Loadable(
  lazy(() => import('../pages/organizations/MemberOrganizations'))
);

export const GmbCustomers = Loadable(lazy(() => import('../pages/GoogleMyBusiness/GmbCustomers')));
export const GmbPartners = Loadable(lazy(() => import('../pages/GoogleMyBusiness/GmbPartners')));
export const GmbTransactions = Loadable(
  lazy(() => import('../pages/GoogleMyBusiness/GmbTransactions'))
);

export const GmbSetupApiKeyPage = Loadable(
  lazy(() => import('../pages/GoogleMyBusiness/GmbSetupApiKeyPage'))
);
export const GmbTransactionInvoice = Loadable(
  lazy(() => import('../pages/GoogleMyBusiness/GmbTransactionInvoice'))
);

export const ManageAccount = Loadable(lazy(() => import('../pages/ManageAccount')));
export const ProfilePage = Loadable(lazy(() => import('../pages/ProfilePage')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
